import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Button from "../../utils/Button";
import Input from "../../utils/Input";
import RegisterLayout from "../../components/Signup";

export default function AdminRegister() {
    

  return (
    <div className="min-h-screen flex items-center justify-center bg-black">
     <RegisterLayout role="Admin"/>
    </div>
  );
}
